<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

<!-- {{formSchema}} -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Project Code"
                v-model="formSchema.project_code"
                :rules="[v => !!v || 'Project code is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Project Name"
                v-model="formSchema.project_name"
                :rules="[v => !!v || 'Project name is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Project Name (in Short)"
                v-model="formSchema.project_name_short"
                :rules="[v => !!v || 'Project name (in short) is required !',lng10]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-textarea
                label="Project Objectives"
                v-model="formSchema.project_objectives"
                :rules="[v => !!v || 'Project objectives is required !']"
                required
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:5,fieldName:'project_start_date', fieldValue:formSchema.project_start_date, label:'Project Start Date'}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <DatePicker              
                :key="formSchema.id"
                :inputData="{index:4,fieldName:'project_end_date', fieldValue:formSchema.project_end_date, label:'Project End Date',disabled:'1'}"
                ref="setRange"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                label="Project Location"               
                v-model="formSchema.project_location"
                :items="locationList"
                :rules="[v => !!v || 'Project location is required !']"
                required
              ></v-select>
            </v-flex> 

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Total Project Cost (USD) (Million)"
                v-model="formSchema.total_project_value_usd"
                :rules="[rules.decimalOnly]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="Total Project Cost (BDT) (Lac)"
                v-model="formSchema.total_project_value_bdt"
                :rules="[rules.decimalOnly]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>             
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'financing_agreement_date', fieldValue:formSchema.financing_agreement_date, label:'Financing Agreement Date', required:'1'}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:2,fieldName:'administration_agreement_date', fieldValue:formSchema.administration_agreement_date, label:'Administration Agreement Date', required:'1'}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:3,fieldName:'project_approval_date', fieldValue:formSchema.project_approval_date, label:'Project Approval Date', required:'1'}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

                       
          </v-layout>

            <v-layout wrap>
            <div style="background-color:#ccc; width:100%; padding:9px; font-weight:bold; text-align:center;">Project Code</div>
            <v-flex xs12 sm6 md3>
              <v-text-field
                label="Single Code"
                v-model="formSchema.single_code"
                
              ></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm6 md3>
              <v-text-field
                label="ADP Code"
                v-model="formSchema.adp_code"
                :rules="[v => !!v || 'Adp code is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                label="Non ADP Code"
                v-model="formSchema.non_adp_code"
                :rules="[v => !!v || 'Non adp code is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                label="Operating Activity Code"
                v-model="formSchema.operating_activity_code"
                :rules="[v => !!v || 'Operating activity code is required !']"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            
              <v-flex xs12 sm6 md6>       
              <div style="background-color:#ccc; width:100%; padding:9px; font-weight:bold; text-align:center;">Implementing Agency</div>             
                <div class="divInline">
                  <!-- <v-checkbox
                    v-model="formSchema.bd_bank"
                    label="Bangladesh Bank"                    
                    :value="checkboxVal"
                  ></v-checkbox> -->
                  <v-autocomplete
                    label="Implementing Agency"               
                    v-model="formSchema.bd_bank"
                    :items="agencyList"
                    item-value="id"
                    item-text="dev_partner_name"
                    clearable
              ></v-autocomplete>
                </div>
              </v-flex>

               <v-flex xs12 sm6 md6>    
               <div style="background-color:#ccc; width:100%; padding:9px; font-weight:bold; text-align:center;">Administrative Ministry/Division</div>            
                <div class="divInline">
                  <v-checkbox
                    v-model="formSchema.finance_ministry"
                    label="Finance Ministry"
                    :value="checkboxVal"
                  ></v-checkbox>
                </div>
              </v-flex>

            </v-layout>

        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <template v-if="revision>0">  
        <v-btn v-if="formSchema.id" color="primary" @click="submitOperationActivities">
        Revision
      </v-btn>
      </template>

      <template v-else>      
      <v-btn color="primary" @click="submitOperationActivities">
        Save & Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>  
       <v-btn v-if="formSchema.id" color="primary" @click="nextStep">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>    
      </template>
     
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      valid: true,
      e1: 0,
      show: false,

      checkboxVal:1,
      revision: sessionStorage.getItem("revision"),
      operation_act_id: sessionStorage.getItem("operation_act_id"),

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      locationList:[
          'Dhaka',
          'Khulna',
          'Rajshahi',
          'Rangpur',
          'Sylhet',
          'Barisal',
      ],
      agencyList:[],

      rules: {
        decimalOnly: value => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        }
      },

      formSchema: {
        id: 0,
        project_code:"",
        project_name: "",
        project_name_short: "",
        project_objectives: "",
        total_project_value_usd: "",
        total_project_value_bdt: "",
        financing_agreement_date: "",
        administration_agreement_date: "",
        project_approval_date: "",
        project_start_date:"",
        project_end_date: "",
        project_location: "",
        adp_code: "",
        non_adp_code: "",
        operating_activity_code: "",
        single_code:"",
        bd_bank:"",
        finance_ministry:"",
        status:null,
      }
    };
  },

  created() {
   
    if(this.operation_act_id)   
    {
      this.loadData();
    }    
    commonService
        .getAllData("implementing-agency2")
        .then(res => {
            this.agencyList = res.data
            console.log('agency', this.agencyList)
        })
        .catch(err => {
          console.log(err)
        })
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "project_start_date"){
        this.formSchema.project_end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
      
    },

    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.operation_act_id, "operation-activities-list")
        .then(res => {
          if (res.data) {
            this.formSchema = res.data;

            this.formSchema.financing_agreement_date = this.changeFormateDMY(
              res.data.financing_agreement_date
            );
            this.formSchema.administration_agreement_date = this.changeFormateDMY(
              res.data.administration_agreement_date
            );
            this.formSchema.project_approval_date = this.changeFormateDMY(
              res.data.project_approval_date
            );
            this.formSchema.project_start_date = this.changeFormateDMY(
              res.data.project_start_date
            );
            this.formSchema.project_end_date = this.changeFormateDMY(
              res.data.project_end_date
            );
            console.log("this.formSchema = ", this.formSchema);
          }
          this.show = true;
        });
    },

    submitOperationActivities() {
     if (this.$refs.form.validate()) {        
          this.submitForm();
      };
    },

    submitForm() {
      
      this.$refs.loader.loaderEnabled();

      let root = this;      
      let formSchema = this.formSchema;

      formSchema.financing_agreement_date = root.changeFormateYMD(
        formSchema.financing_agreement_date
        );
      formSchema.administration_agreement_date = root.changeFormateYMD(
        formSchema.administration_agreement_date
        );
      formSchema.project_approval_date = root.changeFormateYMD(
        formSchema.project_approval_date
        );
      formSchema.project_start_date = root.changeFormateYMD(
        formSchema.project_start_date
        );
      formSchema.project_end_date = root.changeFormateYMD(
        formSchema.project_end_date
        );
      
      formSchema.revision = (root.revision >0) ? 1 : null;

      let functionName = "insertFormData";
      if (formSchema.id > 0) {
        functionName = "updateFormData";
      }

      commonService[functionName](formSchema, "operation-activities").then(
        res => {
          if (res.status == 1) {                      
            sessionStorage.setItem("operation_act_id", res.data.id);
            setTimeout(function() {
              root.date_formate('dmy');
              root.nextStep();
            }, 3000);
            this.SnackbarVal.color = "success";
          }
          else
          {
            this.SnackbarVal.color = "error"; 
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
        }
      );     
    },

    date_formate(formate)
    {

      let formSchema = this.formSchema;
    

      formSchema.financing_agreement_date = this.changeFormateDMY(
        formSchema.financing_agreement_date
        );
      formSchema.administration_agreement_date = this.changeFormateDMY(
        formSchema.administration_agreement_date
        );
      formSchema.project_approval_date = this.changeFormateDMY(
        formSchema.project_approval_date
        );
      formSchema.project_start_date = this.changeFormateDMY(
        formSchema.project_start_date
        );
      formSchema.project_end_date = this.changeFormateDMY(
        formSchema.project_end_date
        );
    },

    nextStep(data) {    
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
  position: absolute !important;
  left: 37%;
}
</style>


// WEBPACK FOOTER //
// src/components/project_info/operation_activities/step_forms/operationActivitiesForm.vue